module.exports = __webpack_public_path__ + "img/symbol_5.2f5b59cc.png";